<template>
  <div class="key-value">
    <dt>
      <slot name="label">{{ label }}</slot>
    </dt>
    <dd>
      <slot name="value">{{ value }}</slot>
    </dd>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>
